module.exports = __webpack_public_path__ + "img/error.f599bf6d.svg";